export default "__VITE_ASSET__COQm0C3E__"